import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoStepLeftButtons]',
  host: {
    class: 'xpo-StepButtons--left',
  },
})
export class XpoStepLeftButtonsDirective {}
